import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import Link from '../Link/Link';
import React from 'react';
const LinkBox = ({ icon, text, onClick }) => {
    return (_jsxs("div", Object.assign({ "data-testid": "linkBox", onClick: onClick, className: cn('d-flex') }, { children: [_jsx(Link, { underline: true, text: text }), icon] })));
};
export default LinkBox;
